import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { label: "Videos", to: "/videos" },
  { label: "Insights", to: "/insights" },
  { label: "Tools", to: "/tools" },
  { label: "Newsletter", to: "/newsletter" },
  { label: "About", to: "/about" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full bg-white/85 backdrop-blur-md border-b border-[#E5E7EB]">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Logo />

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm font-medium transition-colors hover:text-[#1A6B5A] ${
                pathname === l.to ? "text-[#1A6B5A]" : "text-[#3E577A]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <button
            data-testid="nav-start-assessment-btn"
            onClick={() => navigate("/scan")}
            className="bg-[#1A6B5A] text-white hover:bg-[#135245] transition-colors rounded-sm px-5 py-2.5 text-sm font-semibold"
          >
            Start Free Assessment
          </button>
        </div>

        <button
          className="md:hidden text-[#1B3A6B]"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-[#E5E7EB] bg-white px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="text-[#3E577A] font-medium"
            >
              {l.label}
            </Link>
          ))}
          <button
            onClick={() => { setOpen(false); navigate("/scan"); }}
            className="bg-[#1A6B5A] text-white rounded-sm px-5 py-2.5 text-sm font-semibold"
          >
            Start Free Assessment
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
